import AuthWrapper from 'components/AuthWrapper';
import BlockingSpinnerOverlay from 'components/BlockingSpinnerOverlay';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import locationShape from 'shapes/locationShape';
import identityClient from '../../../clients/identityClient';
import errorMessages from '../../../helpers/errorMessages';
import { error as err } from '../../NewRegistrationFlow/PreSignUp';
import ErrorAlert from '../../NewRegistrationFlow/PreSignUp/ErrorAlert';
import AuthWrapperSecondary from '../../Verify/AuthWrapperSecondary';

const NoMatchFound = ({ location }) => {
    const username = location.state?.username;
    const workflowType = location.state?.workflowType
    const firstName = location.state?.firstName;
    const lastName = location.state?.lastName;

    const [error, setError] = useState(err);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const onCancelRegister = () => {
        history.push({
            pathname: '/account/link',
            search: location.search,
            state: { email: '' },
        });
    };

    const onRegister = async () => {
        try {
            setLoading(true);
            await identityClient.sendRegistrationOTP(
                username,
                '',
                undefined,
                workflowType,
            );
            history.push({
                pathname: '/account/link/confirm',
                state: {
                    email: username,
                    hStreamId: '',
                    workflowType,
                    firstName: firstName,
                    lastName: lastName,
                },
                search: window.location.search,
            });
        } catch (e) {
            const status = e.response?.data?.status ?? e.response?.status;
            const detail = e.response?.data?.detail;
            setError({
                ...error,
                errorFound: true,
                errorMessage:
                    status === 400 || status === 409
                        ? detail
                        : errorMessages.processing.message,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthWrapper
            secondary={<AuthWrapperSecondary />}
        >
            {error?.errorFound && <ErrorAlert error={error} />}
            <div
                className="position-relative py-2"
                aria-busy={loading || undefined}
            >
                <BlockingSpinnerOverlay
                    show={loading}
                    ariaLabel="Loading..."
                />
                <p className="AuthWrapper__register__fontsize">
                    <div className="font-weight-bold pb-1 AuthWrapper__register__wordbreak">We didn't find an hStream ID for:</div> <p className="AuthWrapper__register__wordbreak">{username}</p>
                </p>
                <div>
                    <Row className="py-3 d-flex align-items-center">
                        <Col sm="9">
                            <div className="AuthWrapper__register__fontsize font-weight-bold">Register with this email</div>
                        </Col>
                        <Col sm="3">
                            <Button
                                id="noMatchFoundContinue"
                                color="primary"
                                block
                                className="btn btn-sm float-right"
                                onClick={onRegister}
                                disabled={loading}
                            >
                                {loading ? 'Loading...' : 'Continue'}
                            </Button>
                        </Col>
                    </Row>
                    <hr />
                    <Button
                        id="loginWithDifferentUser"
                        color="link"
                        className="btn btn-sm p-0"
                        onClick={onCancelRegister} >
                        Try a different email
                    </Button>
                </div>
            </div>

        </AuthWrapper>
    );
};

NoMatchFound.propTypes = {
    location: locationShape.isRequired,
    search: PropTypes.string,
};

export default withRouter(NoMatchFound);
